import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const BarsArrowDownIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="solid/bars-arrow-down"><path id="Icon" fillRule="evenodd" clipRule="evenodd" d="M2.40002 4.49998C2.40002 4.00292 2.80297 3.59998 3.30002 3.59998H17.1C17.5971 3.59998 18 4.00292 18 4.49998C18 4.99703 17.5971 5.39998 17.1 5.39998H3.30002C2.80297 5.39998 2.40002 4.99703 2.40002 4.49998ZM2.40002 8.99998C2.40002 8.50292 2.80297 8.09998 3.30002 8.09998H12.3099C12.8069 8.09998 13.2099 8.50292 13.2099 8.99998C13.2099 9.49703 12.8069 9.89998 12.3099 9.89998H3.30002C2.80297 9.89998 2.40002 9.49703 2.40002 8.99998ZM16.8 8.39998C17.2971 8.39998 17.7 8.80292 17.7 9.29998L17.7 17.2081L20.0405 14.6876C20.3787 14.3233 20.9482 14.3022 21.3124 14.6405C21.6767 14.9787 21.6978 15.5481 21.3595 15.9124L17.4595 20.1124C17.2892 20.2958 17.0503 20.4 16.8 20.4C16.5498 20.4 16.3108 20.2958 16.1405 20.1124L12.2405 15.9124C11.9023 15.5481 11.9234 14.9787 12.2876 14.6405C12.6519 14.3022 13.2213 14.3233 13.5595 14.6876L15.9 17.2081L15.9 9.29998C15.9 8.80292 16.303 8.39998 16.8 8.39998ZM2.40002 13.5C2.40002 13.0029 2.80297 12.6 3.30002 12.6H8.77448C9.27154 12.6 9.67448 13.0029 9.67448 13.5C9.67448 13.997 9.27154 14.4 8.77448 14.4H3.30002C2.80297 14.4 2.40002 13.997 2.40002 13.5Z" fill="currentColor" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default BarsArrowDownIcon;